import { table } from './_table';
import { tasks } from './tasks';
export const campaigns = {
  namespaced: true,
  modules: {
    table,
    tasks
  }
};
